<template>
  <div v-if="computedBottomSheet">
    <BottomSheet :bottom-sheet="computedBottomSheet"></BottomSheet>
  </div>
  <div v-else-if="computedModal" :class="(computedModal.icon ? 'alert-modal ' : '') + 'modal fade'" :id="customId"
       tabindex="-1" role="dialog" :aria-labelledby="customId+'ModalLabel'" :aria-describedby="computedModal.title">
    <div :class="'modal-dialog ' + computedModal.dimension">
      <div class="modal-content">
        <div class="modal-header">
          <svg class="icon" v-if="computedModal.icon">
            <use :href="'/dist/svg/sprites.svg#'+computedModal.icon"></use>
          </svg>
          <h1 v-if="computedModal.title && serviceDetailStore.language=='it'" class="modal-title h5 no_toc" :id="customId+'ModalLabel'">
            {{ computedModal.title }}</h1>
          <h1 v-if="computedModal.titleEn && serviceDetailStore.language=='en'" class="modal-title h5 no_toc" :id="customId+'ModalLabel'">
            {{ computedModal.titleEn }}</h1>
          <h2 v-else class="visually-hidden" :id="customId+'ModalLabel'">titolo modale</h2>
          <button v-if="computedModal.closable" class="btn-close" type="button" data-bs-dismiss="modal"
                  aria-label="Chiudi finestra modale" style="min-width: 44px; min-height: 44px">
            <svg class="icon">
              <use href="/dist/svg/sprites.svg#it-close"></use>
            </svg>
          </button>
        </div>
        <div :class="'modal-body ' + computedModal.customClass ? computedModal.customClass : ''"
             v-if="computedModal.content">
          <keep-alive>
            <component :is="computedModal.content.render"
                       :class="computedModal.content.customClass ?? ''"
                       v-on="computedModal.content.events ?? []"
                       v-bind="computedModal.content.content ?? {}"></component>
          </keep-alive>
        </div>
        <div class="modal-footer" >
          <keep-alive>
            <component v-if="computedModal.footer" :is="computedModal.footer.render"
                       :class="computedModal.footer.customClass ?? ''"
                       v-on="computedModal.footer.events ?? []"
                       v-bind="computedModal.footer.content ?? {}"></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onBeforeMount, onMounted, Ref, watch} from "vue";
import {IModal} from "@/interfaces/components/general/IModal";
//@ts-ignore
import {Modal} from 'bootstrap-italia';
import BottomSheet from "@/components/general/BottomSheet.vue";
import {IBottomSheet} from "@/interfaces/components/general/IBottomSheet";
import {idRandomGenerator} from "cdp-fe-commons-layout";

import { useServiceDetailStore } from "@/stores/service/serviceDetail";

const serviceDetailStore = useServiceDetailStore();


const props = withDefaults(defineProps<{
  customId?: string
  modal: IModal
}>(), {customId: idRandomGenerator()})


const emits = defineEmits<{
  (e: 'shown', id: string): void,
  (e: 'hidden', id: string): void,
}>()
const computedModal = computed(() => props.modal)
  console.debug('computedModal',computedModal)
const computedBottomSheet: Ref<IBottomSheet | undefined> = computed(() => {
  if (computedModal.value?.bottomSheet === true) {
    return {
      title: computedModal.value.title,
      titleEn: computedModal.value.titleEn,
      content: computedModal.value.content,
      show: computedModal.value.show
    } as IBottomSheet
  }
})

console.debug('computedBottomSheet',computedBottomSheet)

let modalBootstrap: any | null = null;

onMounted(() => {
  const modalElement: HTMLElement | null = document.getElementById(props.customId)
  if (modalElement !== null) {
    modalBootstrap = Modal.getOrCreateInstance(modalElement);
    modalElement.addEventListener('hidden.bs.modal', function () {
      emits('hidden', props.customId)
      removeFade()
    })
    modalElement.addEventListener('shown.bs.modal', function () {
      emits('shown', props.customId)
    })
  }
})

function removeFade() {
  const fade: Element | null = document.getElementsByClassName("modal-backdrop fade show").item(0);
  if (fade !== null) {
    fade.remove();
  }
}

onBeforeMount(() => {
  if (!computedModal.value.show) {
    removeFade();
  }
})

watch(computedModal, (value) => {
  if (modalBootstrap !== null && value.show) {
    modalBootstrap.toggle();
  }
}, {deep: true})

watch(() => computedModal.value.show, (value, oldValue) => {
  if (modalBootstrap !== null && oldValue != undefined && value !== oldValue) {
    modalBootstrap.toggle();
  }
})

</script>
<style scoped>
.modal {
  z-index: 10000 !important;
}
</style>
